export default __webpack_public_path__ + "static/privacy_center@2x-bbdc8ac8479384fc62b38ce912945b72.jpg";